import {observable} from 'mobx';
import {construct, ModelProperties, createInstance} from 'utils';
import {AccessRole} from './access-role';
import {AccessGroup} from './access-group';

export class AccessRolePermission {
    @observable roleId!: number;

    @observable groupId!: number;

    @observable read!: boolean;

    @observable create!: boolean;

    @observable update!: boolean;

    @observable delete!: boolean;

    @observable role?: AccessRole;

    @observable group?: AccessGroup;

    constructor(permissions?: ModelProperties<AccessRolePermission>) {
        if (permissions) {
            construct(this, permissions);
            this.role = createInstance(AccessRole, permissions.role);
            this.group = createInstance(AccessGroup, permissions.group);
        }
    }
}